import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from 'reducers/index';
import { getUserContext } from 'selectors/user';

import CloseIcon from '@zola/zola-ui/src/components/SvgIcons/Close';
import LogoutButton from 'components/LogoutButton';
import {
  Container,
  Overlay,
  Close,
  SearchButton,
  StyledSearchIcon,
  StyledCaretIcon,
  BackToPrimaryCategoriesBtn,
  bottomBorder,
  buttonMarginTop,
} from './MobileNavMenu.styles';

import getMobileNavMenuData from './MobileNavMenuData';
import type { MobileNavMenuLinkGroups } from './MobileNavMenuData/MobileNavMenuData';
import MobileNavMenuLinkGroup from './MobileNavMenuLinkGroup';
import MobileNavUtilityLinks from './MobileNavUtilityLinks';
import SignUpLogin from './SignUpLogin';

export type MobileNavMenuProps = {
  isMenuOpen?: boolean;
  toggleSearch: () => void;
  toggleMenu: () => void;
};

const MobileNavMenu = ({
  isMenuOpen,
  toggleSearch,
  toggleMenu,
}: MobileNavMenuProps): JSX.Element => {
  const userContext = useSelector((state: RootState) => getUserContext(state));
  const [menuData, setMenuData] = useState<MobileNavMenuLinkGroups | undefined>();
  const menuLinks = getMobileNavMenuData(userContext);

  const updateMenu = (newMenuData: MobileNavMenuLinkGroups) => {
    setMenuData(newMenuData);
  };

  const handleAllBtnClick = () => {
    setMenuData(undefined);
  };

  return (
    <Fragment>
      <Overlay isMenuOpen={isMenuOpen} onClick={toggleMenu} />
      <Container isMenuOpen={isMenuOpen}>
        <Close aria-label="Close" type="button" onClick={toggleMenu}>
          <CloseIcon />
        </Close>
        {menuData?.title ? (
          <Fragment>
            <BackToPrimaryCategoriesBtn onClick={handleAllBtnClick}>
              <StyledCaretIcon direction="left" viewBox="0 0 15 9" />
              All
            </BackToPrimaryCategoriesBtn>
            <MobileNavMenuLinkGroup
              title={menuData.title}
              linkGroups={menuData}
              setMenuData={updateMenu}
            />
          </Fragment>
        ) : (
          <Fragment>
            <SearchButton onClick={toggleSearch}>
              <StyledSearchIcon />
              Search Zola
            </SearchButton>
            {menuLinks.map((linkGroup, index) => {
              return (
                <MobileNavMenuLinkGroup
                  key={index}
                  css={menuLinks.length - 1 > index ? bottomBorder : undefined}
                  title={linkGroup.title}
                  linkGroups={linkGroup}
                  setMenuData={updateMenu}
                />
              );
            })}
          </Fragment>
        )}
        <SignUpLogin />
        <MobileNavUtilityLinks />
        <LogoutButton css={buttonMarginTop} />
      </Container>
    </Fragment>
  );
};

export default MobileNavMenu;
